import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6366e6dd"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "box"
};
const _hoisted_2 = {
  class: "login_box"
};
const _hoisted_3 = {
  class: "back"
};
const _hoisted_4 = {
  class: "cont-main"
};
const _hoisted_5 = {
  class: "tabs"
};
const _hoisted_6 = {
  class: "index-slide-nav"
};
const _hoisted_7 = {
  style: {
    "margin-top": "18px"
  }
};
import api from "@/api";
import { showToast, showLoadingToast, showSuccessToast, showFailToast } from "vant";
import { reactive } from "vue";
import router from "@/router";
//import vueImgVerify from '../../components/vueImgVerify.vue'
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const data = reactive({
      username: null,
      password: '',
      verify: '',
      cancode: null,
      show: false,
      account: ''
    });
    const submit = async () => {
      if (!data.username) return showToast('请输入正确的用户名');
      if (data.username.length < 4) return showToast('请输入正确的用户名');
      if (!data.password) return showToast('请输入正确的登录密码');
      if (data.password.length < 6) return showToast('请输入正确的登录密码');
      await api.login(data.username, data.password).then(res => {
        if (res.data.code == 0) {
          window.localStorage.setItem('user', JSON.stringify(res.data.data));
          showToast('登录成功');
          setTimeout(() => {
            router.push({
              path: '/'
            });
          }, 1000);
        } else {
          showToast(res.data.msg);
        }
      });
    };
    const forget = async () => {
      data.show = true;
    };
    const beforeClose = async e => {
      if (e === 'confirm') {
        if (!data.account) return showToast('请先输入账号');
        showLoadingToast('请稍后...');
        await api.forgetPwd(data.account).then(res => {
          console.log(res);
          if (res.data.code == 0) {
            data.show = false;
            data.account = '';
            showSuccessToast('密码重置成功，请查看短信');
          } else {
            showFailToast(res.data.msg);
          }
        });
      }
      if (e === 'cancel') {
        data.show = false;
      }
    };
    return (_ctx, _cache) => {
      const _component_router_link = _resolveComponent("router-link");
      const _component_van_field = _resolveComponent("van-field");
      const _component_van_button = _resolveComponent("van-button");
      const _component_van_form = _resolveComponent("van-form");
      const _component_van_dialog = _resolveComponent("van-dialog");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_router_link, {
        to: "/",
        style: {
          "color": "#7b7b7b"
        }
      }, {
        default: _withCtx(() => [_createTextVNode("返回首页")]),
        _: 1
      })]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createVNode(_component_router_link, {
        to: "/login"
      }, {
        default: _withCtx(() => [_createTextVNode("登录")]),
        _: 1
      }), _createVNode(_component_router_link, {
        to: "/register"
      }, {
        default: _withCtx(() => [_createTextVNode("注册")]),
        _: 1
      })])]), _createVNode(_component_van_form, null, {
        default: _withCtx(() => [_createVNode(_component_van_field, {
          modelValue: data.username,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => data.username = $event),
          name: "用户名",
          placeholder: "输入您的用户名",
          rules: [{
            required: true
          }]
        }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
          modelValue: data.password,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => data.password = $event),
          type: "password",
          name: "密码",
          placeholder: "输入您的登录密码",
          rules: [{
            required: true
          }]
        }, null, 8, ["modelValue"]), _createElementVNode("p", {
          class: "forget",
          onClick: _cache[2] || (_cache[2] = $event => data.show = true)
        }, "忘记密码"), _createElementVNode("div", _hoisted_7, [_createVNode(_component_van_button, {
          round: "",
          block: "",
          style: {
            "background": "#64aa55",
            "color": "#fff"
          },
          "native-type": "submit",
          onClick: submit
        }, {
          default: _withCtx(() => [_createTextVNode(" 登录 ")]),
          _: 1
        })])]),
        _: 1
      })])]), _createVNode(_component_van_dialog, {
        show: data.show,
        "onUpdate:show": _cache[4] || (_cache[4] = $event => data.show = $event),
        title: "重置登录密码",
        "show-cancel-button": "",
        "before-close": beforeClose,
        "confirm-button-disabled": !data.account
      }, {
        default: _withCtx(() => [_withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => data.account = $event),
          placeholder: "请输入您要重置的账号",
          style: {
            "padding": "10px",
            "width": "80%",
            "margin-top": "5px"
          }
        }, null, 512), [[_vModelText, data.account]])]),
        _: 1
      }, 8, ["show", "confirm-button-disabled"])]);
    };
  }
});